import reducer, { actions, initialState } from './reducer';

export default {
  actions,
  reducer,
  initialState,
};
